import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TotalRecordCountService {
  private totalCountSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor() {}

  setTotalRecordCount(count: number) {
    this.totalCountSubject.next(count);
  }

  getTotalRecordCount() {
    return this.totalCountSubject.asObservable();
  }
}
